/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import * as Msdyn365 from '@msdyn365-commerce/core';
import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';

import { IMoeFileListProps } from './moe-file-list.props.autogenerated';
import { IMoeFileListData } from './moe-file-list.data';
import { COLLECTIONS_SITE_LANGUAGE, KWR } from '../../utilities/constants';
import { getToggleLang, getUserPrefLang, getUserPreferredLanguage } from '../../utilities/language-change';
// import { getArtifactsByItemAsync } from '../../actions/extensions/DataActionExtension.g';

/**
 * The interface for IImageListViewProps.
 */
export interface IImageListViewProps extends IMoeFileListProps<IMoeFileListData> {
    imageList: IModuleProps;
    imageListHeading?: React.ReactNode;
    imageListContainer: INodeProps;
    imageListItem: INodeProps;
    imageListItemAnchorTag: INodeProps;
    imageListItems: IImageListItem[] | undefined;
}

/**
 * The interface for IImageListItem.
 */
export interface IImageListItem {
    image: JSX.Element | undefined;
    documentType: string | undefined;
    link: string | undefined;
    linkAltText: string | undefined;
    linkAriaLabel: string | undefined;
}

/**
 *
 * ImageList component.
 * @extends {React.PureComponent<IMoeFileListProps<IMoeFileListData>>}
 */
class ImageList extends React.PureComponent<IMoeFileListProps<IMoeFileListData>> {
    public render(): JSX.Element | null {
        const { context } = this.props;
        const user = this.props.context.request.user;
        const { fileListHeader, fileListHeaderInMaori } = this.props.config;

        // Identify language
        const toggleLang = getToggleLang(context);
        const userPrefLang = getUserPrefLang(user.customerAccountNumber as any, context);
        const fileListSiteLang = getUserPreferredLanguage(KWR, COLLECTIONS_SITE_LANGUAGE, userPrefLang, toggleLang, context);

        // const customerInfo = this._getProducts();
        const imageListTitle = fileListHeader && (
            <Msdyn365.Text
                className='ms-moe-doc-list_title'
                tag={'span'}
                text={fileListSiteLang === 'maori' ? fileListHeaderInMaori : fileListHeader}
            />
        );
        const viewProps: IImageListViewProps = {
            ...(this.props as IMoeFileListProps<IMoeFileListData>),
            imageList: {
                moduleProps: this.props,
                className: classnames('ms-moe-doc', this.props.config.className),
                tag: 'div'
            },
            imageListHeading: imageListTitle,
            imageListContainer: {
                className: 'ms-moe-doc-list',
                role: 'list',
                tag: 'ul'
            },
            imageListItem: {
                className: 'ms-image-list__list-item',
                role: 'listitem',
                tag: 'li'
            },
            imageListItemAnchorTag: {
                tag: 'a',
                className: 'ms-image-list__link',
                role: 'link'
            },
            imageListItems: undefined
        };
        console.log('Inside File List');
        return this.props.renderView(viewProps);
    }

    // private async _getProducts(): Promise<any> {
    //     try {
    //         // eslint-disable-next-line @typescript-eslint/await-thenable
    //         const customerInfo: any = await this.props.data.products;
    //         return customerInfo;
    //     } catch (err) {
    //         console.log(err);
    //     }
    // }

    /**
     * Render list of images.
     * @returns List of images with text and redirection link.
     */
    // private readonly _renderImageListItems = (): IImageListItem[] | undefined => {
    //     const imageList: IDocumentsData[] | undefined = this.props.config.documents;
    //     const defaultImageSettings: Msdyn365.IImageSettings = {
    //         viewports: {
    //             xs: { q: 'w=65&h=65&q=80&m=6', w: 65, h: 65 },
    //             lg: { q: 'w=65&h=65&q=80&m=6', w: 65, h: 65 },
    //             xl: { q: 'w=65&h=65&q=80&m=6', w: 65, h: 65 }
    //         },
    //         lazyload: false,
    //         disableLazyLoad: true
    //     };
    //     return imageList?.map((item, index) => {
    //         const { link, documentType } = item;

    //         const imageProps = {
    //             gridSettings: this.props.context.request.gridSettings!,
    //             imageSettings: defaultImageSettings
    //         };

    //         const imageLink: string | undefined = link?.linkUrl.destinationUrl;
    //         const imageLinkText: string | undefined = link?.linkText ?? link?.ariaLabel;
    //         const imageLinkAriaLabel: string | undefined = link?.ariaLabel;

    //         const imageImage = <Msdyn365.Image {...imageProps} loadFailureBehavior='empty' requestContext={this.props.context.request} />;

    //         const imageListItem: IImageListItem = {
    //             image: imageImage,
    //             link: imageLink,
    //             documentType: documentType,
    //             linkAltText: imageLinkText,
    //             linkAriaLabel: imageLinkAriaLabel
    //         };
    //         console.log(imageListItem);
    //         return imageListItem;
    //     });
    // };
}

export default ImageList;
